/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import type { Format } from 'devextreme/common';

import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-chart-argument-format',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoChartArgumentFormatComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get currency(): string {
        return this._getOption('currency');
    }
    set currency(value: string) {
        this._setOption('currency', value);
    }

    @Input()
    get formatter(): ((value: number | Date) => string) {
        return this._getOption('formatter');
    }
    set formatter(value: ((value: number | Date) => string)) {
        this._setOption('formatter', value);
    }

    @Input()
    get parser(): ((value: string) => number | Date) {
        return this._getOption('parser');
    }
    set parser(value: ((value: string) => number | Date)) {
        this._setOption('parser', value);
    }

    @Input()
    get precision(): number {
        return this._getOption('precision');
    }
    set precision(value: number) {
        this._setOption('precision', value);
    }

    @Input()
    get type(): Format | string {
        return this._getOption('type');
    }
    set type(value: Format | string) {
        this._setOption('type', value);
    }

    @Input()
    get useCurrencyAccountingStyle(): boolean {
        return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value: boolean) {
        this._setOption('useCurrencyAccountingStyle', value);
    }


    protected get _optionPath() {
        return 'argumentFormat';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoChartArgumentFormatComponent
  ],
  exports: [
    DxoChartArgumentFormatComponent
  ],
})
export class DxoChartArgumentFormatModule { }
